export const transactionsConfig = {
    "tableDefinition": {
        "tooltip": "",
        "columns": [
            {
                "name": "akey",
                "label": "Policy Number",
                "displayField": "akey"
            },
            {
                "name": "status",
                "label": "Transaction Status",
                "displayField": "astatus"
            },
            {
                "name": "action",
                "label": "Action",
                "displayField": "action"
            }
        ]
    }
}